package org.multipaz.doctypes.generated

/**
 * Central access point for localized strings.
 * DO NOT EDIT - This file is auto-generated by the generateMultipazStrings task
 */
object GeneratedTranslations {

    private val defaultMap = strings_en

    private val map_ar = strings_ar
    private val map_cs = strings_cs
    private val map_da = strings_da
    private val map_de = strings_de
    private val map_el = strings_el
    private val map_en = strings_en
    private val map_es = strings_es
    private val map_fr = strings_fr
    private val map_he = strings_he
    private val map_hi = strings_hi
    private val map_id = strings_id
    private val map_it = strings_it
    private val map_ja = strings_ja
    private val map_ko = strings_ko
    private val map_nl = strings_nl
    private val map_pl = strings_pl
    private val map_pt = strings_pt
    private val map_ru = strings_ru
    private val map_th = strings_th
    private val map_tr = strings_tr
    private val map_uk = strings_uk
    private val map_vi = strings_vi
    private val map_zh_rCN = strings_zh_rCN

    val allLanguages: List<String> = listOf(
        "ar",
        "cs",
        "da",
        "de",
        "el",
        "en",
        "es",
        "fr",
        "he",
        "hi",
        "id",
        "it",
        "ja",
        "ko",
        "nl",
        "pl",
        "pt",
        "ru",
        "th",
        "tr",
        "uk",
        "vi",
        "zh-rCN"
    )

    /**
     * Returns the string map for the given locale.
     * Falls back to 'en' if the locale is not available.
     *
     * @param locale The locale code (e.g., "en", "es", "de")
     * @return Map of string keys to localized values
     */
    fun getMapForLocale(locale: String): Map<String, String> {
        return when (locale) {
            "ar" -> map_ar
            "cs" -> map_cs
            "da" -> map_da
            "de" -> map_de
            "el" -> map_el
            "en" -> map_en
            "es" -> map_es
            "fr" -> map_fr
            "he" -> map_he
            "hi" -> map_hi
            "id" -> map_id
            "it" -> map_it
            "ja" -> map_ja
            "ko" -> map_ko
            "nl" -> map_nl
            "pl" -> map_pl
            "pt" -> map_pt
            "ru" -> map_ru
            "th" -> map_th
            "tr" -> map_tr
            "uk" -> map_uk
            "vi" -> map_vi
            "zh-rCN" -> map_zh_rCN
            else -> defaultMap
        }
    }

    /**
     * Returns the localized string for the given key and language.
     * Falls back to the default language, then to the key itself if not found.
     *
     * @param key The string key
     * @param lang The language code (e.g., "en", "es", "de")
     * @return The localized string or the key as fallback
     */
    fun getString(key: String, lang: String): String {
        val map = getMapForLocale(lang)
        return map[key] ?: defaultMap[key] ?: key
    }

    /**
     * Checks if the given key exists in the specified language.
     *
     * @param key The string key to check
     * @param lang The language code
     * @return true if the key exists in the language map
     */
    fun containsKey(key: String, lang: String): Boolean {
        return getMapForLocale(lang).containsKey(key)
    }
}
